import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FETCH_OFFERS, SET_TAB } from 'dealer-reducers'
import { RootReducer } from '../../redux/rootReducer'
import Layout from '../layout/Layout'
import { useTranslation } from 'react-i18next'
import InRealizationSvg from '../other/svg/InRealizationSvg'
import { ListOffer } from 'dealer-types'
import FlatList from '../molecules/FlatList'
import RealizationItemWrapper from '../molecules/RealizationItemWrapper'
import OfferModal from './OfferModal'
import PaginatedOffers from './PaginatedOffers'
import OfferFilters from '../molecules/OfferFilters'

const Realization = (): JSX.Element => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const containerRef = useRef<HTMLDivElement>(null)
  const { offers } = useSelector((state: RootReducer) => state.offersListReducer.in_realization)
  const { paginationType } = useSelector((state: RootReducer) => state.layoutReducer)
  const tab = useSelector((state: RootReducer) => state.offersListReducer.tab)

  useEffect(() => {
    dispatch(SET_TAB({ tab: 'in_realization' }))
    dispatch(FETCH_OFFERS({ tab: 'in_realization' }))
  }, [dispatch])

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  return (
    <div>
      <Layout
        iconComponent={<InRealizationSvg className="w-12 h-12 text-white" />}
        withFiler={true}
        name={t('in_realization')}>
        <div>
          <OfferFilters containerRef={containerRef} />

          <div className="h-[calc(100vh-200px)]">
            {paginationType === 'infinite' && (
              <FlatList
                data={offers}
                component={(itemProps: ListOffer) => <RealizationItemWrapper {...itemProps} />}
                // eslint-disable-next-line require-await
                fetchMore={async () => {
                  dispatch(FETCH_OFFERS({ tab: 'in_realization' }))
                  // eslint-disable-next-line @typescript-eslint/return-await
                  return Promise.resolve()
                }}
                itemMinWidth={'100%'}
              />
            )}
            {paginationType === 'paginated' && tab === 'in_realization' && (
              <PaginatedOffers component={RealizationItemWrapper} />
            )}
          </div>
        </div>
      </Layout>
      <OfferModal />
    </div>
  )
}

export default Realization
